import { useRef } from "react";
import { IComponent } from "../services/http/component/models/IComponent";
import { getColorVariables, getColorVariantClassname } from "../shared/helpers";

interface UseIndicatorState
{
    indicatorStatus: IndicatorStatus;
    hasNoIndicators: boolean;
}

interface IndicatorStatus
{
    text: string;
    color: string;
    className: string;
}

export function useIndicators(component: IComponent): UseIndicatorState
{
    const { healthIndicatorStatusId, healthIndicatorScore, offlineIndicatorId, offlineIndicatorScore } = component;
    const hasHealthIndicator = has(healthIndicatorScore) && healthIndicatorStatusId > 0;
    const hasOfflineIndicator = has(offlineIndicatorScore) && offlineIndicatorId > 0;
    const hasHealthIndicatorOnly = !hasOfflineIndicator && hasHealthIndicator;
    const hasOfflineIndicatorOnly = !hasHealthIndicator && hasOfflineIndicator;
    const hasNoIndicators = !hasHealthIndicator && !hasOfflineIndicator;
    const hasBothIndicators = hasHealthIndicator && hasOfflineIndicator;
    const indicatorStatus = useRef<IndicatorStatus>({ text: '', color: '', className: ''});

    function has(x: number): boolean
    {
        return x !== undefined && x !== null;
    }

    function getText(): string
    {
        if (hasHealthIndicatorOnly) return `${(healthIndicatorScore * 100).toFixed(0)}%`;
        if (hasOfflineIndicatorOnly) return offlineIndicatorScore === 0 ? "Offline" : "Online";
        if (hasBothIndicators) return offlineIndicatorScore === 0 ? "Offline" : `${(healthIndicatorScore * 100).toFixed(0)}%`;
        return null as any;
    }

    function getColorAndClassName(returnColor: boolean): string
    {
        if (hasHealthIndicatorOnly)
            return returnColor
                ? getColorVariables(healthIndicatorStatusId)
                : getColorVariantClassname(healthIndicatorStatusId);

        if (hasOfflineIndicatorOnly)
            return offlineIndicatorScore === 0 ? "offline" : "warning";

        if (hasBothIndicators)
            return offlineIndicatorScore === 0 ? "offline" : returnColor
                ? getColorVariables(healthIndicatorStatusId)
                : getColorVariantClassname(healthIndicatorStatusId);

        return null as any;
    }

    indicatorStatus.current = {
        text: getText(),
        color: getColorAndClassName(true),
        className: getColorAndClassName(false)
    };

    return { hasNoIndicators, indicatorStatus: indicatorStatus.current };
}